export const tabs = (buttons, tabs) => {

    if (buttons.length) {
        buttons.forEach(function (item, index) {
            item.addEventListener('click', function () {
                buttons.forEach(function (subItem) {
                    subItem.classList.remove('active');
                })
                item.classList.add('active');

                tabs.forEach(function (subItem) {
                    subItem.classList.remove('active');
                })
                tabs[index].classList.add('active');
            })
        })
    }

}
